var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8957 14.4855C39.6339 13.6756 38.9155 13.1003 38.0655 13.0237L26.5205 11.9754L21.9552 1.29001C21.6186 0.50691 20.852 0 20.0002 0C19.1484 0 18.3818 0.50691 18.0452 1.29184L13.48 11.9754L1.93303 13.0237C1.08462 13.1021 0.368046 13.6756 0.104673 14.4855C-0.158701 15.2955 0.0845308 16.1839 0.726332 16.7439L9.45306 24.3973L6.87975 35.7327C6.69145 36.5662 7.01495 37.4277 7.70649 37.9276C8.07821 38.1962 8.51309 38.3329 8.95164 38.3329C9.32976 38.3329 9.70483 38.231 10.0415 38.0295L20.0002 32.0775L29.9553 38.0295C30.6838 38.4678 31.6021 38.4278 32.2921 37.9276C32.9839 37.4262 33.3071 36.5644 33.1188 35.7327L30.5455 24.3973L39.2722 16.7454C39.914 16.1839 40.1591 15.297 39.8957 14.4855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStar);
export default __webpack_public_path__ + "static/media/white-star.f0637744ca1b2a21cf3c26c24cb787fa.svg";
export { ForwardRef as ReactComponent };